import type * as React from 'react';
import type { InjectedExperimentsProps } from '@wix/wix-experiments-react';
import { withExperiments as experimetnsInjector } from '@wix/wix-experiments-react';

export const withExperiments: any = (
  component: React.ComponentType<InjectedExperimentsProps>,
) => experimetnsInjector(component);
